// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map-legend[data-v-78105d5e]{border:2px solid var(--primary-color);border-radius:8px;padding:16px;margin-top:-48px}h3[data-v-78105d5e]{margin:0 0 16px 0;color:var(--primary-color)}.legend-categories[data-v-78105d5e]{display:flex;flex-wrap:wrap;color:var(--secondary-color);font-weight:500}", ""]);
// Exports
module.exports = exports;
